import { useGetOrganizationNavigateSetup } from '../Organization/Client/queries'

type Props = {
  username: string
  organization: string
}

export default function LoggedInNavigate(props: Props) {
  useGetOrganizationNavigateSetup({
    organization: props.organization,
    username: props.username,
  })
  return null
}
